import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import LocalStorage from '../../LocalStorage';

const FrontLayout = () => {
    /*** Determine authorized users by token ***/
    const isLoggedIn = LocalStorage.isLoggedIn();
    /*** Return output ***/
    return (
        <div className="layout-front app-wrapper">
            <div className="container-sm app-content">
                <div className="row justify-content-md-center">
                    <div className="col-lg-5 col-md-6 col">
                        <Header />
                        <Outlet />
                        {isLoggedIn ? <Footer /> : null}
                    </div>
                </div>
            </div>
        </div>
    );
}


export default FrontLayout;